module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n3r4n8n-401090592ba21ce5975435c55870aa26.svg";